/** Shared width for Gross, Deprec./Impair. and Net period columns. */
export const EXPERT_BALANCE_SHEET_AMOUNT_COLUMN_WIDTH = '185px'

export const EXPERT_BALANCE_SHEET_COLUMN_WIDTHS = {
  amount: EXPERT_BALANCE_SHEET_AMOUNT_COLUMN_WIDTH,
} as const
